import { mutator } from 'satcheljs';
import { type AFTER_UNSUBSCRIBEActionMessage, onAfterUnsubscribe } from '../actions/publicActions';
import { default as UnsubscribeResponseType } from '../store/schema/unsubscribeResponseType';

/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: AFTER_UNSUBSCRIBEActionMessage) => void = mutator(
    onAfterUnsubscribe,
    actionMessage => {
        const { unsubscribeSourceType, responseType, debugMessage, completedCallback } =
            actionMessage;
        // The completeCallback is handled by brands card and it has its own error handling
        if (unsubscribeSourceType === 'BrandCard' && completedCallback) {
            completedCallback(
                responseType === UnsubscribeResponseType.Success /* isSuccess */,
                debugMessage
            );
        }
    }
);
export default defaultExport;
